import React from "react";
import "../../styles/MyTeam.css";

const MyTeam = () => {
  const teamMembers = [
    {
      name: "Basavaraj Kolur",
      role: "Software Engineer",
      department: "IT",
    },
    {
      name: "Deepak",
      role: "HR Manager",
      department: "HR",
    },
    {
      name: "Arun",
      role: "Employee",
      department: "IT",
    },
  ];

  return (
    <div className="my-team-container">
      <h2>My Team</h2>
      <p className="team-subtitle">
        View your team members and their details.
      </p>

      <div className="team-grid">
        {teamMembers.map((member, index) => (
          <div className="team-card" key={index}>
            <div className="team-avatar">
              {member.name.charAt(0)}
            </div>

            <div className="team-info">
              <h3>{member.name}</h3>
              <p>{member.role}</p>
              <span>{member.department}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyTeam;